import { DESTINATION_PORT, MISSING_PORT_CONTENT } from 'components/CruiseSearchWidget/constants';
import { FiltersSearchBar } from 'components/FiltersModal/FilterSearchBar/FilterSearchBar';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { PillButton } from 'components/buttons/PillButton/PillButton';
import { ListFilterOption } from 'lib/apiClient';
import { useCallback, useMemo } from 'react';

import styles from './PortsList.css';

interface PortsListProps {
	filterKey: string;
	label: string;
	ports: ListFilterOption[];
}

interface PortsGroup {
	letter: string;
	ports: ListFilterOption[];
}

export const PortsList = ({ filterKey, label, ports }: PortsListProps) => {
	const { updateSelection } = useFiltersContext();
	const alphabetUppercase = useMemo(() => Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)), []);

	const portsGroups: PortsGroup[] = alphabetUppercase.map((letter) => {
		const optionsMatch = ports.filter((port) => port.label[0].toUpperCase() === letter);
		return {
			letter,
			ports: optionsMatch,
		};
	});

	const searchOptions = useMemo<ListFilterOption[]>(() => {
		return ports.filter((item) => item.label !== MISSING_PORT_CONTENT);
	}, [ports]);

	const handleOptionClick = useCallback(
		(filter: string | undefined, value: string, containers: Array<string> | undefined) => {
			if (!filter) return;
			updateSelection(filter, { value: [value], containers });
		},
		[updateSelection],
	);

	return (
		<div className={styles.root}>
			<FiltersSearchBar searchData={searchOptions} filterKey={DESTINATION_PORT} />
			{label && <span className={styles.subTitle}>{label}</span>}
			<div className={styles.group}>
				{portsGroups.map((group) => {
					if (group.ports.length > 0) {
						return (
							<div className={styles.group} key={group.letter}>
								<div className={styles.letter}>{group.letter}</div>
								<div className={styles.ports}>
									{group.ports.map((port) => (
										<PillButton
											key={port.code}
											testId={`${filterKey}-pill-button-${port.code}`}
											label={port.label}
											onClick={() => handleOptionClick(filterKey, port.code, port.containers)}
											isSelected={port.isSelected}
											isDisabled={port.isDisabled}
										/>
									))}
								</div>
							</div>
						);
					}
				})}
			</div>
		</div>
	);
};
